import React, { useEffect, useRef } from 'react';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';
import intl from 'react-intl-universal';

import DateJS from '@/utils/date';
import { downloadBlobFile } from '@/utils';
import Storage from '@/utils/storage';
import { exportOrderLog } from '@/api/order';

import SearchForm, { SearchFormRef } from '@/pages/order/operationLog/components/SearchForm';
import TableList from '@/pages/order/operationLog/components/TableList';
import { useLogState } from '@/pages/order/operationLog/helper';

import styles from './index.module.scss';

const ActionLog = () => {
  const { loadingStatus, dataSource, setLoadingStatus, queryLogData } = useLogState();
  const searchFormRef = useRef<SearchFormRef>();
  const { resvNo } = useParams<any>();

  // 查询列表
  const getTableData = () => {
    queryLogData({
      ...searchFormRef.current.getFormValue(),
      orderNo: resvNo,
      pageNum: 1,
      pageSize: 10000,
    });
  };

  // 导出
  const exportLogData = async () => {
    setLoadingStatus(true);
    try {
      const res: any = await exportOrderLog({
        ...searchFormRef.current.getFormValue(),
        orderNo: resvNo,
      });
      // 共用码+订单日志+导出时间精确到秒.xlsx
      downloadBlobFile(
        new Blob([res]),
        intl.get('order_operation_log_export_file_name', {
          commonCode: Storage.get('commonCode'),
          time: DateJS().format('YYYYMMDDHHmmss'),
        }),
      );
    } catch (_) {
      //
    }
    setLoadingStatus(false);
  };

  useEffect(() => {
    getTableData();
  }, []);

  return (
    <div className={styles.pageContainer}>
      <Spin spinning={loadingStatus}>
        <SearchForm
          defaultValue={null}
          innerRef={searchFormRef}
          onChange={getTableData}
          onExport={exportLogData}
        />
        <div className={styles.tableWrapper}>
          <TableList dataSource={dataSource} getTableData={getTableData} />
        </div>
      </Spin>
    </div>
  );
};

export default ActionLog;
